import React from "react";
import { Row, Col, Input, Button } from "reactstrap";

const OperationPanel = ({ search,hideSearch, setSearch, filters = [], onAdd, addLabel = "Add",showAddButton = true }) => {
  return (
    <div className="d-flex flex-column flex-md-row align-items-center justify-content-between">      
      <Row className="mb-3 gy-1 align-items-center w-100">
        {!hideSearch ? (
          <Col md={4} className="px-0 px-md-2">
            <Input
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Col>
        ) : (
          <Col md={4} xs={12} className="px-0 px-md-2">
            <div className="text-muted fw-semibold">
              Manage Records
            </div>
          </Col>
        )}
        

        {filters.map((filter, i) => (
          <Col md={3} xs={12} className="px-0 px-md-2" key={i}>
            <Input
              type="select"
              value={filter.value}
              onChange={(e) => filter.onChange(e.target.value)}
            >
              <option value="">{filter.placeholder}</option>
              {filter.options?.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </Input>
          </Col>
        ))}

        {showAddButton && (
          <Col md="auto" xs={12} className="ms-md-auto px-0 px-md-2">
            <Button
              color="primary"
              className="btn-rounded w-100 w-md-auto"
              onClick={onAdd}
            >
              <i className="mdi mdi-plus me-1"></i>
              {addLabel}
            </Button>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default OperationPanel;